/**
 * CancellationPathway schema — SCRUM-295 (DS-021, Payments BC).
 *
 * The funds-resolution pathway a staff member chooses when a reservation is
 * cancelled. The single source of truth for the wire vocabulary validated by
 * the HTTP DTO (`POST /organizations/:slug/folios/:folioId/cancellation-pathway`).
 *
 * The matching domain type is a PLAIN TypeScript union
 * (`CancellationPathway` in `payments/domain/folio/folio.entity.ts`) — the
 * domain depends on nothing, so it does NOT import this Zod schema, and this
 * package (a leaf shared with the external frontends) does NOT import the API
 * app. The two are kept in lock-step by the `satisfies` check below: the values
 * array is asserted assignable to the same string union the domain declares, so
 * any drift (a renamed or added pathway on one side) fails typecheck.
 *
 * DISTINCT from booking's cancellation-POLICY vocabulary
 * (`'Hold-credit' | 'Disburse' | 'Cancellation-fee'`) — different concept,
 * different bounded context, different values, no reconciliation.
 */
import { z } from 'zod';
export const CANCELLATION_PATHWAYS = [
    'FutureStayCredit',
    'Disburse',
    'CancellationFee',
];
export const cancellationPathwaySchema = z.enum(CANCELLATION_PATHWAYS);
//# sourceMappingURL=cancellation-pathway.schema.js.map